import haversine from "haversine";

export class FlightDistanceCalculator {
    static calculateDistance(pointA, pointB, emissionFactor) {
        const distance = haversine(pointA, pointB, { unit: "km" });

        return distance;
    }
}